import { render, staticRenderFns } from "./AddMemberToWorkshift.vue?vue&type=template&id=0c4b2f12"
import script from "./AddMemberToWorkshift.vue?vue&type=script&lang=js"
export * from "./AddMemberToWorkshift.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports